"use strict";

export class Footer {
  constructor() {
    
  }
}
